module.exports = __webpack_public_path__ + "c5623380642a412c4144914f2b302591.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-jam.png
// module id = 1595
// module chunks = 0